import { gql } from "@/__generated__/gql";

export const USER_HAS_ASSIGNED_STUDENTS = gql(`
  query UserHasAssignedStudents(
      $orgId: ID!
      $userId: ID!
  ) {
    node(id: $userId) {
      ... on User {
        id
        hasAssignedStudents(organizationId: $orgId)
      }
    }
  }
`);
